var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "212px",
    height: "80px",
    viewBox: "0 0 212 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Node.js",
    transform: "translate(-17.000000, -52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,16 L60,73 C60,75.209139 61.790861,77 64,77 L153,77 C155.209139,77 157,75.209139 157,73 L157,16 L183,16 C186.865993,16 190,19.581722 190,24 C190,28.418278 186.865993,32 183,32 L205,32 C208.865993,32 212,35.581722 212,40 C212,44.418278 208.865993,48 205,48 L186,48 C182.134007,48 179,51.581722 179,56 C179,60.418278 182.134007,64 186,64 L192,64 C195.865993,64 199,67.581722 199,72 C199,76.418278 195.865993,80 192,80 L140,80 C139.485125,80 138.983234,79.9364709 138.5,79.8158974 C138.016766,79.9364709 137.514875,80 137,80 L46,80 C42.1340068,80 39,76.418278 39,72 C39,67.581722 42.1340068,64 46,64 L7,64 C3.13400675,64 0,60.418278 0,56 C0,51.581722 3.13400675,48 7,48 L47,48 C50.8659932,48 54,44.418278 54,40 C54,35.581722 50.8659932,32 47,32 L22,32 C18.1340068,32 15,28.418278 15,24 C15,19.581722 18.1340068,16 22,16 L60,16 Z M60,15.6687101 C57.1085111,14.6852253 55,11.6240236 55,8 C55,3.581722 58.1340068,0 62,0 L119,0 C122.865993,0 126,3.581722 126,8 C126,8.69059914 125.923432,9.36076016 125.779469,10 L64,10 C61.790861,10 60,11.790861 60,14 L60,15.6687101 Z",
    id: "Combined-Shape",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 61.25,
    y: 11.25,
    width: 94.5,
    height: 64.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.531265,53.389948 C102.406237,52.8737394 99.4999838,49.8088501 99.4999838,45.8406211 C99.4999838,44.227541 100.062498,42.4853835 101,41.3239564 C100.593763,40.259312 100.656261,38.0009797 101.124996,37.0653791 C102.374988,36.9040744 104.062498,37.5815539 105.062498,38.5171545 C106.249992,38.1300234 107.499984,37.9364578 109.031249,37.9364578 C110.562514,37.9364578 111.812506,38.1300234 112.937502,38.4848936 C113.906253,37.5815539 115.625012,36.9040744 116.875004,37.0653791 C117.31249,37.9364578 117.374988,40.1947902 116.968751,41.2916955 C117.968751,42.5176444 118.499984,44.1630192 118.499984,45.8406211 C118.499984,49.8088501 115.593763,52.8092175 111.406237,53.357687 C112.468735,54.0674275 113.187494,55.6160194 113.187494,57.3904379 L113.187494,60.7456755 C113.187494,61.7135371 113.968751,62.2619728 114.906253,61.8748417 C120.562514,59.6487702 125,53.80934 125,46.5826562 C125,37.4525102 117.812506,30 108.968751,30 C100.124996,30 93,37.4525102 93,46.5826562 C93,53.7448182 97.4062369,59.6810312 103.343739,61.9071026 C104.187494,62.2297119 105,61.6490152 105,60.7779364 L105,58.1969611 C104.562514,58.3905603 104,58.5196041 103.499984,58.5196041 C101.437486,58.5196041 100.218743,57.3581769 99.3437389,55.1965936 C99,54.3255486 98.6250124,53.80934 97.9062532,53.7125572 C97.5312654,53.6802963 97.4062369,53.5189917 97.4062369,53.3254261 C97.4062369,52.9382613 98.0312491,52.6479129 98.6562613,52.6479129 C99.5625144,52.6479129 100.343739,53.2286433 101.156245,54.4223314 C101.781257,55.357932 102.437486,55.7773241 103.218743,55.7773241 C104,55.7773241 104.499984,55.4869757 105.218743,54.7449406 C105.750008,54.1964712 106.156245,53.7125572 106.531265,53.389948 Z",
    id: "Path",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.82784,20 L78.118659,20 L151.289772,20 L145.82784,20 L78.118659,20 L154.02323,20 L145.82784,20 Z M73.118659,20 L62,20 L73.118659,20 Z",
    id: "lines",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconnect);
export default __webpack_public_path__ + "static/media/reconnect.9d3e4aefb7eef9ba3450af9a80123a0b.svg";
export { ForwardRef as ReactComponent };